// extracted by mini-css-extract-plugin
module.exports = {"qt-loading-animation":"styles-m__qt-loading-animation__1fJpk"};